import React from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';

import {
  Node,
} from '@uncinc/react-drupal-core';

import {
  Accordion,
} from '@uncinc/uncinc-react-kitchen-sink';

import slugify from '../../../helpers/slugify';

import './style.scss';

const ParagraphFAQ = ({ entity, className }) => {
  const classes = classNames('Paragraph ParagraphFAQ', className);

  const title = entity.getIn(['field_title', 0, 'value'], '');
  const questions = entity.get('field_questions', Immutable.List());

  const slug = slugify(title);

  return (
    <div className={classes} id={slug}>
      <div className="ParagraphFAQ__title">
        <h2>{title}</h2>
      </div>

      <Accordion className="ParagraphFAQParagraphs__paragraphs">
        {questions.map((question) => {
          const id = question.get('target_id');
          const language = question.getIn(['entity', 'langcode', 0, 'value']);
          return (
            <div key={`question:${id}:${language}`}>
              <Node id={question.get('target_id')} entity={question.get('entity')} />
            </div>
          );
        })}
      </Accordion>
    </div>
  );
};

export default ParagraphFAQ;


